export default {
  apiKey: "AIzaSyBvu96jJNx6wOYa5uXxkGOPJcs5TCQADoo",
  authDomain: "nan-dake.firebaseapp.com",
  databaseURL: "https://nan-dake.firebaseio.com",
  projectId: "nan-dake",
  storageBucket: "nan-dake.appspot.com",
  messagingSenderId: "165066274154",
  appId: "1:165066274154:web:5622f2f040560e562ce113",
  measurementId: "G-HQJRT51FFF"
};
